import type { ReactNode } from 'react';
import { Typography } from '@mui/material';

export function EmptyState({ children }: { children: ReactNode }) {
  return (
    <Typography color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
      {children}
    </Typography>
  );
}
